import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

/**
 * Hook que cuenta órdenes de subasta con pago pendiente
 * @param userId - ID del usuario
 * @returns cantidad de órdenes pendientes de pago
 */
export function usePendingAuctionPayments(userId: string | undefined) {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!userId) {
      setCount(0);
      return;
    }

    let mounted = true;

    const fetchCount = async () => {
      try {
        setLoading(true);
        const { count: pendingCount, error } = await supabase
          .from('orders')
          .select('*', { count: 'exact', head: true })
          .eq('user_id', userId)
          .eq('is_auction_order', true)
          .eq('status', 'pending_payment');

        if (error) throw error;

        if (mounted) {
          setCount(pendingCount || 0);
        }
      } catch (err) {
        console.error('Error fetching pending auction payments:', err);
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    fetchCount();

    // Suscribirse a cambios en órdenes de subasta
    const channel = supabase
      .channel('pending-auction-payments')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'orders',
          filter: `user_id=eq.${userId}`,
        },
        (payload) => {
          fetchCount();
        }
      )
      .subscribe();

    return () => {
      mounted = false;
      supabase.removeChannel(channel);
    };
  }, [userId]);

  return { count, loading };
}
